export default __webpack_public_path__ + "static/media/TC.28940ce0.svg";